import React, { useState } from 'react';

const ThumbnailList = React.memo(({ thumbnails = [], onSelect = () => {}, selectedIndex = 0 }) => {
  const renderThumbnails = () => {
    const items = thumbnails.length > 0 ? thumbnails : Array(6).fill({});

    return [...Array(Math.ceil(items.length / 3))].map((_, rowIndex) => {
      const start = rowIndex * 3;
      const rowItems = items.slice(start, start + 3);

      return (
        <div key={rowIndex} style={styles.row}>
          {rowItems.map((thumb, index) => {
            const globalIndex = start + index;
            return (
              <ThumbnailButton
                key={globalIndex}
                index={globalIndex}
                thumbUrl={thumb?.thumbUrl}
                title={thumb?.title}
                isSelected={selectedIndex === globalIndex}
                onClick={() => onSelect(globalIndex)}
              />
            );
          })}
        </div>
      );
    });
  };

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes pulseBorder {
          0% { box-shadow: 0 0 0px rgba(255,105,180, 0.15); }
          50% { box-shadow: 0 0 12px rgba(255,182,193, 0.4); }
          100% { box-shadow: 0 0 0px rgba(255,105,180, 0.15); }
        }
        @keyframes bounceIn {
          0% { transform: scale(0.9); opacity: 0; }
          50% { transform: scale(1.05); opacity: 0.8; }
          100% { transform: scale(1); opacity: 1; }
        }
        @keyframes skeletonPulse {
          0% { background-color: #f0f0f0; }
          50% { background-color: #e0e0e0; }
          100% { background-color: #f0f0f0; }
        }
      `}</style>
      {renderThumbnails()}
    </div>
  );
});

const ThumbnailButton = ({ thumbUrl, onClick, isSelected, index, title }) => {
  const [loaded, setLoaded] = useState(false);
  const displayTitle = title?.trim() || `動画${index + 1}`;

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={`${displayTitle}を再生`}
      aria-pressed={isSelected}
      title={`${displayTitle}`}
      style={{
        ...styles.thumbnailWrapper,
        ...(isSelected ? styles.selectedThumbnail : styles.unselectedThumbnail),
      }}
    >
      {!loaded && <div style={styles.skeleton} />}
      {thumbUrl && (
        <img
          src={thumbUrl}
          alt={`${displayTitle}のサムネイル`}
          loading="lazy"
          width="160"
          height="90"
          onLoad={() => setLoaded(true)}
          onError={() => setLoaded(true)}
          style={{
            ...styles.image,
            display: loaded ? 'block' : 'none',
          }}
        />
      )}
    </button>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '16px 0 28px',
    alignItems: 'center',
    background: 'linear-gradient(145deg, #fff5f9, #ffe0eb)',
    borderRadius: '14px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    gap: '16px',
  },
  thumbnailWrapper: {
    border: 'none',
    background: 'linear-gradient(135deg, #ffe6f0, #fff)',
    padding: 0,
    cursor: 'pointer',
    borderRadius: '12px',
    overflow: 'hidden',
    width: 'clamp(80px, 28vw, 100px)',
    aspectRatio: '16 / 9',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    animation: 'bounceIn 0.4s ease',
    position: 'relative',
  },
  selectedThumbnail: {
    boxShadow: '0 0 0 4px #f06292, 0 0 10px #f8bbd0',
    transform: 'scale(1.1)',
    backgroundColor: '#fff0f8',
  },
  unselectedThumbnail: {
    animation: 'pulseBorder 3s ease-in-out infinite',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '12px',
  },
  skeleton: {
    width: '100%',
    height: '100%',
    borderRadius: '12px',
    animation: 'skeletonPulse 1.5s infinite ease-in-out',
    position: 'absolute',
    top: 0,
    left: 0,
  },
};

export default ThumbnailList;
